import axios from "axios"
import { CollectionQuery } from "../../../models/collection.model"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { PARKING_LOT_ENDPOINT } from "../parking-lot.endpoint"

export const exportSales = async (query: CollectionQuery) => {
  try {
    const url = `${PARKING_LOT_ENDPOINT.export}?${collectionQueryBuilder(query)}`

    const response = await axios.get(url, {
      responseType: "arraybuffer",
    })

    return response.data // This will be the ArrayBuffer
  } catch (error) {
    console.error("Error fetching export pretrips:", error)
    throw error // Re-throw the error for the caller to handle
  }
}
